import styled from 'styled-components';
import { Button, IconButton, InternalButtonSpan } from '../../Button';
import { Flex } from '../../Core';
import { Icon } from '../../Icons';
import { Text } from '../../Text';

// Chips use 1px gaps instead of borders, so Default's border must be suppressed here.
// && (same pattern as HeaderButton.tsx) adds specificity to beat Button's own pseudo-classes.
const noBorder = () => `
  && {
    border-color: transparent;

    &:focus {
      border-color: transparent;
    }

    @media (any-hover: hover) {
      &:hover {
        border-color: transparent;
      }
    }

    &:active {
      border-color: transparent;
    }
  }
`;

export const PropertyButton = styled(Button)`
  color: ${({ theme }) => theme.colors.gray['090']};
  ${noBorder}
`;

export const SelectionButton = styled(Button)`
  border-radius: 0px;
  flex: 1;
  justify-content: flex-start;
  ${noBorder}

  > ${InternalButtonSpan} {
    flex: 1;
    > div {
      justify-content: space-between;
      width: 100%;
    }
  }
`;

// The Add Filter control sits right next to the chip group and reads as part of the same row, so
// it gets the same borderless treatment in light theme.
export const AddFilterButton = styled(Button)`
  ${noBorder}
`;

export const AddFilterIconButton = styled(IconButton)`
  ${noBorder}
`;

export const Middle = styled(Flex)`
  // Matches the flanking chips' own (Default, white/near-white in light theme) fill, rather than
  // a separate hardcoded wash that didn't track either theme's real button color.
  background: ${({ theme }) => theme.backgroundDefaultButton};
  color: ${({ theme }) => theme.colors.gray['090']};
  padding: 0 ${({ theme }) => theme.spacing8}px;
  font-weight: 500;
`;

export const FilterBuilderContent = styled(Flex)`
  ${Button} {
    font-weight: 500;
  }

  flex-wrap: wrap;
`;

export const SelectionRemoveIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.gray['080']};
`;

export const DropdownLabelContainer = styled(Flex)`
  background: ${({ theme }) => theme.colors.gray['050']};
  text-transform: uppercase;
  font-weight: 500;
  line-height: 1;
  border-bottom: solid 1px ${({ theme }) => theme.backgroundDropdown};
`;
DropdownLabelContainer.defaultProps = {
  p: 'spacing4',
  px: 'spacing12',
  gap: 'spacing8',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const ActionableText = styled(Text)`
  &:hover {
    cursor: pointer;
  }
`;

export const FilterClauseWrapper = styled(Flex)`
  flex-wrap: wrap;
  flex-wrap: balance;
  gap: 1px;
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  overflow: hidden;
`;

export const FilterBuilderToggleBadge = styled.span<{ isOpen: boolean }>`
  transition: background 100ms;
  padding: 2px 5px;
  border-radius: 2px;

  ${({ theme }) => `
    background: ${theme.colors.orange.default};
    margin-left: ${theme.spacing4}px;
  `}

  ${({ isOpen, theme }) =>
    isOpen &&
    `
    color: ${theme.colorTextSubtle};
    background: transparent;
  `}
`;
